import React, { Component } from 'react'
import classnames from 'classnames'
import { localize, getLocale } from '../../util/Localizer'
import { Row, Col } from 'react-flexbox-grid'
import RBButton from '../../controls/RBButton'

import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { injectIntl } from 'react-intl'
import { passResponse, goNext } from '../../redux/actions/submitNavigationActions'
import { clearSearch } from '../../redux/actions/submitPractitionerActions'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { withStyles } from '@material-ui/core/styles'

import {
  updateClaim
} from '../../redux/actions/submitAClaimActions'

import { ClaimTypes } from '../../redux/SubmitClaim/Common'

class Navigation extends Component {
  constructor (props) {
    super(props)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handleBack = this.handleBack.bind(this)
    this.updateLoading = this.updateLoading.bind(this)
    this.state = {
      open: false,
      loading: false
    }
  }

  componentDidUpdate (prevProps) {
    const { dialogRsp } = this.props
    if ((dialogRsp !== prevProps.dialogRsp) && (dialogRsp === true || dialogRsp === false)) {
      let common = {
        ClaimCommonInfo: {
          Language: getLocale(),
          PayFromHealthCareSpendingAccount: dialogRsp,
          PendingClaim: false,
          HealthCareSpendingAccountTopUpInfo: null
        }
      }

      if (typeof this.props.updateClaim === 'function') {
        this.props.updateClaim(common)
      }
    }
  }

  handleOpen () {
    this.setState({ open: true })
  }

  updateLoading () {
    this.setState({ loading: false })
  }

  handleClose (e) {
    this.props.passResponse(e)
    this.props.goNext()
    this.setState({ open: false })
  }

  onCancel () {
    this.props.clear()
    this.props.clearSearch()
    this.props.push('/Claims')
  }

  handleNext () {
    if (this.props.dialogMsg) {
      this.handleOpen()
    } else {
      if (this.props.callBacks && this.props.callBacks.onNext) {
        const onNext = this.props.callBacks && this.props.callBacks.onNext
        if (onNext.async === false) {
          this.props.callBacks.onNext.callback()
        } else {
          this.setState({ loading: true })
          this.props.callBacks.onNext.callback(() => this.setState({ loading: false }))
        }
      } else {
        this.props.goNext()
      }
    }
  }

  handleBack () {
    switch (this.props.currentPage) {
      case 'claimTypeBenefit':
        this.props.updateClaim({
          type: ClaimTypes.UNKNOWN,
          claimSubmitType: ''
        })
        break
      case 'practitioner':
        this.props.clearSearch()
        break
      default:
        break
    }

    this.props.goBack()
  }

  submit () {
    this.props.clearTotals()
    this.props.submitClaim()
  }

  renderBackButton () {
    const props = this.props
    const { classes = {} } = props

    if (this.props.currentPage !== 'terms' && this.props.currentPage !== 'member') {
      return (<RBButton variant='outlined' label={localize('common.back')} disabled={props.pageStack === []} onClick={this.handleBack} className={classes.button} />)
    }

    return null
  }

  renderDialogLines (lines) {
    return lines.map((line, idx) => {
      if (line.small) {
        return (
          <span key={idx}>
            <small>{line.text}</small>
            <br />
          </span>
        )
      } else {
        return (
          <span key={idx}>
            {line.text}<br />
          </span>
        )
      }
    })
  }

  render () {
    let props = this.props
    const { classes = {} } = props
    const { dialogMsg } = props
    return (
      <Row end='xs' middle='xs'>
        <Col xs={12} className={classes.buttonBar}>
          <RBButton variant='outlined' label={localize('common.cancel')} className={classes.button} onClick={() => this.onCancel()} />
          {this.renderBackButton()}
          {props.pageNext === 'submit' && <RBButton variant='contained' label={localize('pages.SubmitAClaim.CertificationAndAuthorization.IAgreeAndSubmit')} primary className={classnames(classes.button, classes.lastButton)} onClick={() => this.submit()} loading={props.showLoading} />}
          {props.pageNext !== 'submit' && <RBButton variant='contained' label={localize('common.next')} primary={props.pageNext !== null} disabled={props.pageNext === null} className={classnames(classes.button, classes.lastButton)} onClick={() => this.handleNext()} loading={this.state.loading} />}
        </Col>
        {this.state.open
          ? <Dialog
            open={this.state.open}
            onClose={this.handleClose}
          >
            <DialogTitle className={classes.dialogTitle}>
              {
                (() => {
                  if (!dialogMsg) {
                    return null
                  } else if (typeof dialogMsg.title === 'function') {
                    return dialogMsg.title()
                  } else {
                    return dialogMsg.title
                  }
                })()
              }
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              {
                (() => {
                  if (!dialogMsg) {
                    return null
                  } else if (typeof dialogMsg.message === 'function') {
                    return dialogMsg.message()
                  } else {
                    return (
                      <p>{dialogMsg.message}</p>
                    )
                  }
                })()
              }
              {
                (() => {
                  if (!dialogMsg) {
                    return null
                  } else if (typeof dialogMsg.note === 'function') {
                    return dialogMsg.note()
                  } else {
                    return (
                      <p><small>{dialogMsg.note}</small></p>
                    )
                  }
                })()
              }
              <DialogActions>
                <RBButton
                  variant='outlined'
                  label={localize('yesText')}
                  onClick={() => this.handleClose(true)}
                  className={classes.dialogButton}
                />
                <RBButton
                  variant='outlined'
                  label={localize('noText')}
                  onClick={() => this.handleClose(false)}
                  className={classes.dialogButton}
                />
              </DialogActions>
            </DialogContent>
          </Dialog> : null}
      </Row>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const {
    dialogRsp = null,
    dialogMsg = null,
    callBacks
  } = state.SubmitNavigationReducer

  return { dialogMsg, dialogRsp, callBacks }
}

const ConnectedNavigation = connect(mapStateToProps, {
  push,
  passResponse,
  goNext,
  clearSearch,
  updateClaim
  // onNext
})(injectIntl(Navigation))

const styles = {
  buttonBar: {
    textAlign: 'right'
  },
  button: {
    margin: 5
  },
  lastButton: {
    marginRight: 0
  },
  dialogTitle: {
    textAlign: 'center'
  },
  dialogContent: {
    textAlign: 'center'
  },
  dialogButton: {
    margin: 10
  }
}

export default withStyles(styles)(ConnectedNavigation)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/Navigation.js